<template>
  <div class="page_one ">
    <swiper
      class="swiper_wrappre"
      @slideChange="onSlideChange"
      :options="swiperOption"
      ref="mySwiper1"
    >
      <swiper-slide
        class="swiper_item flex-eju-center"
        :class="[page.className]"
        v-for="(page, index) in pageConfig"
        :key="index"
      >
        <div class="page_content" v-if="(activeIndex === index || (loopIndex === 0 && activeIndex === 3) || (loopIndex === 5 && activeIndex === 0)) && !page.noShowContent">
          <vue-typed-js class="type_wrapper" :strings="[page.typingString]" :showCursor="showCursor" @onComplete="onComplete(page.className)">
            <div class="typing"></div>
          </vue-typed-js>
          <div class="content_wrapper flex-eju-center">
            <div class="banner_group flex-eju-align animate__animated animate__fadeInUp" v-if="page.showBannerGroup">
              <img src="@/assets/svg/page_1/banner-企业微信.svg" />
              <i class='iconfont yqyxinghao'></i>
              <img src="@/assets/svg/page_1/banner-易企盈.svg" />
              <i class='iconfont yqyhutui'></i>
              <img src="@/assets/svg/page_1/banner-微信.svg" />
            </div>
            <div class="tip_word animate__animated animate__fadeInUp" >{{page.tipWord}}</div>
            <div class="tip_word animate__animated animate__fadeInUp" v-if="page.tipWord2">{{page.tipWord2}}</div>
            <div class="use_btn animate__animated animate__fadeInUp" @click="showMask"><div class="animate_hover">立即体验</div></div>
          </div>
        </div>
        
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>
<script>
import { VueTypedJs } from 'vue-typed-js'
export default {
  components: {
    VueTypedJs
  },
  props: {
    activePageIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    activePageIndex: {
      handler: function(val) {
        if (val === 0) {
          // this.showPage = true
        }
      },
    }
  },
  data() {
    return {
      showCursor: false,
      showPage: false,
      activeIndex: 0,
      loopIndex: 1,
      swiperOption: {
        speed: 300,
        // loop : true,
        initialSlide: 0,
        initialSlide: this.activeIndex,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 允许点击小圆点跳转
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // }
      },
      pageConfig: [
        {
          showBannerGroup: true,
          className: "page_1",
          typingString: `企业微信&nbsp;&nbsp;<i class='iconfont yqyxinghao' style='font-size:40px'></i>&nbsp;&nbsp;易企盈&nbsp;&nbsp;<i style='font-size:40px' class='iconfont yqyhutui'></i>&nbsp;&nbsp;打通房地产数字营销流量池`,
          tipWord: '企业微信让每个企业都有自己的微信',
          tipWord2: '企业微信唯一合规且能高频、直连消费者的社交软件'
        },
        {
          noShowContent: true,
          className: "page_2",
        },
        // {
        //   showBannerGroup: false,
        //   className: "page_2",
        //   typingString: '客户为王，找到客户才有成交机会',
        //   tipWord: '高净值客户的维护非一次性的，需要有运营思维，服务好全生命周期'
        // },
        // {
        //   showBannerGroup: false,
        //   className: "page_3",
        //   typingString: '置业顾问是第一生产力，赋能营销环节才能创造更大价值',
        //   tipWord: '置业顾问最能触达客户，以科技为驱动赋能营销，全方面提升获客和成交能力'
        // },
        // {
        //   showBannerGroup: false,
        //   className: "page_4",
        //   typingString: '客户与置业顾问均是企业资产，建立数字化流量池才能获得更大业绩增长',
        //   tipWord: '建立基于企业微信的新型营销生态，形成可触达、可运营、可生长的企业私域流量池'
        // }
      ],
    }
  },
  computed: {
    swiper() {
      console.log(this.$refs.mySwiper1)
      return this.$refs.mySwiper1.swiperInstance;
    },
  },
  methods: {
    showMask() {
      this.$emit('showMask')
    },
    onSlideChange(swiper) {
      console.log(this.swiper);
      console.log("slide change");
      this.activeIndex = this.swiper.activeIndex;
      // this.activeIndex = this.swiper.realIndex;
      // this.loopIndex = this.swiper.activeIndex;
    },
    onComplete() {
      console.log('onComplete')
    }
  }
}
</script>
<style lang="less" scoped>
.page_one {
  width: 100%;
  height: 100%;
  .swiper_wrappre {
    width: 100%;
    height: 100%;
    position: relative;
    .swiper_item {
      &.page_1 {
        background: url('../../../assets/svg/page_1/banner-bg1.svg'), linear-gradient(107.73deg, #0174FF 0%, #5500C1 100%) ;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      &.page_2 {
        background: url('../../../assets/svg/page_1/banner-bg5.svg'), linear-gradient(107.56deg, #0CB9EF 0%, #0017E2 100%), linear-gradient(0deg, #000000, #000000), linear-gradient(107.73deg, #0174FF 0%, #5500C1 100%) ;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      // &.page_2 {
      //   background: url('../../../assets/svg/page_1/banner-bg2.svg'), linear-gradient(107.56deg, #0CB9EF 0%, #0017E2 100%), linear-gradient(0deg, #000000, #000000), linear-gradient(107.73deg, #0174FF 0%, #5500C1 100%) ;
      //   background-size: 100%;
      // }
      // &.page_3 {
      //   background: url('../../../assets/svg/page_1/banner-bg3.svg'), linear-gradient(107.73deg, #00C193 0%, #0036BF 100%);
      //   background-image: url('../../../assets/svg/page_1/banner-bg3.svg');
      //   background-size: 100%;
      // }
      // &.page_4 {
      //   background: url('../../../assets/svg/page_1/banner-bg4.svg'), linear-gradient(107.73deg, #1F6BFF 0%, #9025FC 100%);
      //   background-size: 100%;
      // }
    }
  }
  .page_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    .tip_word {
      font-weight: 300;
      font-size: 24px;
      line-height: 34px;
      color: #FFFFFF;
      margin-top: 10px;
      // margin-bottom: 36px;
    }
    .use_btn {
      margin-top: 36px;
    }
  }
  .content_wrapper {
    flex-direction: column;
    .banner_group {
      padding: 40px 0 30px 0;
    }
    .iconfont {
      font-size: 40px;
      margin: 0 50px;
      color: #fff;
    }
  }
  .type_wrapper {
    display: flex;
    justify-content: center;
    text-align: center;
  }
  .typing {
    font-size: 40px;
    line-height: 56px;
    font-weight: 300;
    color: #fff;
  }
}
.swiper-container{
  --swiper-theme-color:rgba(255, 255, 255, .5);
  --swiper-pagination-color: rgba(255, 255, 255, 1);/* 两种都可以 */
}

</style>
<style lang="less">
.swiper-pagination-bullet {
  height: 4px;
  width: 20px;
  border-radius: 2px;
  background:rgba(255, 255, 255, .5) !important;
  opacity: 1;
}
.swiper-pagination-bullet-active {
  width: 40px;
  background:rgba(255, 255, 255, 1) !important;
}
.swiper-button-prev {
  left: 40px;
}
.swiper-button-next {
  right: 40px;
}
</style>
